<template>
  <div ref="chartEl" class="line-chart"></div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from "vue";
import * as echarts from "echarts";

export default {
  name: "LineChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ date: [], listDate: {} }),
    },
  },
  setup(props) {
    const chartEl = ref(null);
    let chartInstance = null;

    const initChart = () => {
      if (!chartEl.value || !props.chartData.date || !props.chartData.listDate)
        return;

      if (chartInstance) chartInstance.dispose();

      chartInstance = echarts.init(chartEl.value);

      const legendData = Object.keys(props.chartData.listDate);
      const series = legendData.map((name) => ({
        name,
        type: "line",
        data: props.chartData.listDate[name],
        smooth: true,
        itemStyle: {
          color: getSeriesColor(name),
        },
        lineStyle: { width: 2 },
      }));

      chartInstance.setOption({
        // tooltip: { trigger: "axis" },
        legend: {
          data: legendData,
          bottom: "0%",
          textStyle: {
            fontSize: 10,
          },
        },
        grid: {
          left: "1%",
          right: "7%",
          bottom: "13%",
          top: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: props.chartData.date,
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 10,
          },
          axisLine: { lineStyle: { color: "rgba(0, 0, 0, 0.70)" } },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: 10,
          },
          axisLine: { lineStyle: { color: "rgba(0, 0, 0, 0.70)" } },
          splitLine: { lineStyle: { type: "dashed", color: "#F0F0F0" } },
        },
        series,
      });
    };

    const getSeriesColor = (name) => {
      const colorMap = {
        粉条: "#F5A623",
        芒果: "#8979FF",
        花火: "#FF928A",
        增量: "#3CC3DF",
      };
      return colorMap[name];
    };

    const handleResize = () => {
      if (chartInstance) chartInstance.resize();
    };

    onMounted(() => {
      initChart();
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      if (chartInstance) chartInstance.dispose();
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => props.chartData,
      () => {
        initChart();
      },
      { deep: true }
    );

    return { chartEl };
  },
};
</script>

<style scoped>
.line-chart {
  width: 100%;
  height: 220px;
}
</style>
